export default __webpack_public_path__ + "static/media/logo.e6f12bc6.svg";